<template>
	<div class="zhongContainer">

		<div class="section">
			<!-- 导航 -->
			<div class="navBar">
				<img class="navLogo" src="../assets/logo2.png" alt="" @click="enterHome()" />
				<ul class="navBarItem">
					<!-- <li class="busiz-active-sel">
						<router-link exact to="/" tag="a">首页</router-link>
					</li> -->
					<li>
						<router-link to="/aboutlanshu" exact tag="a">关于兰树</router-link>
					</li>
					<el-dropdown>
						<li class="brandLi">
							<router-link exact to="/huaiBrand" style="font-size: 1em" tag="a">兰树品牌</router-link>
						</li>
						<el-dropdown-menu class="elDropdown" exact slot="dropdown"
							style="background: rgb(236, 245, 255) !important">
							<el-dropdown-item>
								<li>
									<router-link :class="brandActive == '1' ? 'elDropdown_active' : ''"
										style="background: rgb(236, 245, 255) !important; color: #000 !important; "
										to="/huaiBrand" tag="a">
										淮树</router-link>
								</li>
							</el-dropdown-item>
							<el-dropdown-item>
								<li>
									<router-link :class="brandActive == '2' ? 'elDropdown_active' : ''"
										style="background: rgb(236, 245, 255) !important; color: #000 !important; "
										to="/brand" tag="a">心清堂
									</router-link>
								</li>
							</el-dropdown-item>
							<el-dropdown-item>
								<li>
									<router-link :class="brandActive == '3' ? 'elDropdown_active' : ''"
										style="background: rgb(236, 245, 255) !important; color: #000 !important; "
										to="/shuiBrand" tag="a">
										水姻缘</router-link>
								</li>
							</el-dropdown-item>
							<el-dropdown-item>
								<li>
									<router-link :class="brandActive == '4' ? 'elDropdown_active' : ''"
										style=" background: rgb(236, 245, 255) !important; color: #000 !important;"
										to="/yiBrand" tag="a">
										一清堂</router-link>
								</li>
							</el-dropdown-item>
							<el-dropdown-item>
								<li>
									<router-link :class="brandActive == '5' ? 'elDropdown_active' : ''"
										style=" background: rgb(236, 245, 255) !important; color: #000 !important;"
										to="/zhongBrand" tag="a">Dr.CHUNG<span
											style="vertical-align: super;">+</span></router-link>
								</li>
							</el-dropdown-item>

							<el-dropdown-item>
								<li>
									<router-link :class="brandActive == '6' ? 'elDropdown_active' : ''"
										style=" background: rgb(236, 245, 255) !important; color: #000 !important;"
										to="/lanshuBrand" tag="a">兰树</router-link>
								</li>
							</el-dropdown-item>
							<el-dropdown-item>
								<li>
									<router-link :class="brandActive == '7' ? 'elDropdown_active' : ''"
										style=" background: rgb(236, 245, 255) !important; color: #000 !important;"
										to="/zbqfBrand" tag="a">植本清方</router-link>
								</li>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<li><router-link to="/park" exact tag="a">智慧园区</router-link></li>
					<li>
						<router-link to="/brandLanshu" exact tag="a">美业菩提</router-link>
					</li>
					<li><router-link to="/school" exact tag="a">兰树商学院</router-link></li>

					<li>
						<router-link to="/dynamicLanshu" exact tag="a">菩提基金会</router-link>
					</li>

					<li>
						<router-link to="/lanshuTrends" exact tag="a">兰树动态</router-link>
					</li>
				</ul>
			</div>

		</div>

		<div class="topImg">
			<img src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_11-19-23_24077.png" alt="">
		</div>

		<div class="customer">
			<div class="leftImg">
				<img src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_11-19-55_61675.png"
					alt="">
			</div>

			<div class="rightText">
				<div class="title" style="display: flex;">Dr.CHUNG<span class="upjia">+</span>「肌肤的时间管理者」</div>
				<div class="content">
					肌肤，是时光的艺术,我们恐惧时间流过的痕迹，但从未放弃掌控时间。这一次，我们想改变肌肤老去的定律，来一场穿梭在肌肤时间轴上的探秘。深耕新世代生活方式,依托深厚的医学底蕴。Dr.CHUNG<span
						style="vertical-align: super;">+</span>，带来全新定制化护肤体验。这里有咖啡馆午后般适意的线下空间,有更多选择性自助休闲服务，帮你在呵护护肤的静态时间里，享受时光凝驻的惊喜。我们深谙新世代内心需求,增加打卡护肤与社交属性推出品牌设计款居家用品,让护肤更贴近生活我们希望帮助年轻的肌肤,卸下肌肤沉重的负担，释放城市人性的自由。光阴不会停止
					但你会被时光定格,<span>Dr.CHUNG<span style="vertical-align: super;">+</span></span> 做你的肌肤的时间管理者。</div>
			</div>

		</div>

		<div class="fgLine">
			THE SKIN'S TIME MANAGER
		</div>

		<div class="recommend">
			<div class="white-background"></div>
			<div class="recImg">
				<img src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_11-21-27_77103.png"
					alt="">
			</div>

			<div class="series">
				<div class="series-title">
					<div class="stitle">
						Dr.CHUNG<span class="upjia">+</span>「产品系列推荐」
					</div>
					<div class="scontent">
						定位中国中高端的护肤品牌。我们品牌以专业的皮肤学科为基础，站在以护肤管理服务为核心内容，为年轻一代提供轻松自在的护肤解决方案。
					</div>

					<div class="more">
						点击查看更多系列
					</div>
				</div>


				<div class="allSeries">
					<div class="prev">
						<img src="../assets/yiBrand/prev.png" @click="arrowClick('prev')" />
					</div>
					<div class="carousel">
						<el-carousel arrow="never" height="50vh" :interval="2000" :autoplay="true"
							indicator-position="none" ref="cardShow">
							<el-carousel-item v-for="(item, index) in datalist" :key="index">
								<div class="box">
									<div class="left">
										<div class="cover" @click="goList(item.id1)">
											<img :src="item.img1" alt="">
										</div>

									</div>
									<div class="right">
										<div class="cover" @click="goList(item.id2)">
											<img :src="item.img2" alt="">
										</div>
									</div>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
					<div class="next">
						<img src="../assets/yiBrand/next.png" @click="arrowClick('next')" />
					</div>
				</div>

			</div>



		</div>




		<div class="section pageBox6">
			<div class="pageBoxOut2">
				<!-- 底部 -->
				<div class="footerBox">
					<div class="footerBoxHeader">
						<div class="footerBoxHeaderLeft">
							<img class="codeImg" src="../assets/code.png" alt="">
							<span class="codeText">兰树公众号</span>
						</div>
						<div class="footerBoxHeaderRight">
							<img class="codeImg" src="../assets/xcxNew.jpg" alt="">
							<span class="codeText">兰树云小程序</span>
						</div>
						<!-- <div class="footerBoxHeaderRight">
								<img class="codeImg" src="../assets/code.png" alt="">
								<span class="codeText">兰树客服(QQ)</span>
							</div> -->

					</div>
					<div class="footerMainBox">
						<li class="footerShop"><a target="_blank"
								href="https://huaishu.tmall.com/shop/view_shop.htm?spm=a230r.7195193.1997079397.2.124378dduXIhiW">淮树旗舰店</a>
						</li>
						<li class="footerShop"><a target="_blank"
								href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">心清堂官方企业店</a>
						</li>
						<li class="footerShop"><a target="_blank" href="https://shop349169226.taobao.com/?spm=a21xtw.29978516.0.0">水姻缘旗舰店</a></li>
						<li class="footerShop"><a target="_blank"
								href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">一清堂官方企业店</a>
						</li>
						<li class="footerShop"><a target="_blank" href="https://drchung.tmall.com"><span>Dr.CHUNG</span>旗舰店</a></li>
						<li class="footerShop"><a target="_blank" href="https://zhibenqingfang.tmall.com">植本清方旗舰店</a></li>
						<div class="lastHeader">
							<li><router-link to="/login" tag="a">登录</router-link></li>
							|
							<li><router-link to="/login" tag="a">注册</router-link></li>
						</div>
					</div>
					<div class="footerInfoBox">
						<div class="emailBox">邮箱: postermaster@lasur.com</div>
						<div class="phoneBox">电话: 0571-89025888</div>
						<div class="addressBox">地址: 浙江省杭州市之江东路越秀·维多利中心A座 17楼</div>
					</div>

					<div class="footerLine"></div>
					<div class="footerBoxBottom">
						<div class="footerLeft">
							Copyright © 2023 兰树化妆品股份有限公司 <a target="_blank"
								href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a> |
							<img style="width: 16px;" src="../assets/plice.png" />&nbsp;<a target="_blank"
								href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
								33052102000740号</a>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	data() {
		return {
			datalist: [{
				img1: require("../assets/yiBrand/site-1.png"),
				name1: "倾城秘颜眼部系列",
				color1: "yellow",
				img2: require("../assets/yiBrand/site-2.png"),
				name2: "嫱颜玉润精粹系列",
				color2: "purple"
			},
			{
				img1: require("../assets/yiBrand/site-3.png"),
				name1: "美蝉光感蕴能系列",
				color1: "white",
				img2: require("../assets/yiBrand/site-4.png"),
				name2: "玉奴清滢平衡系列",
				color2: "red"
			},
			{
				img1: require("../assets/yiBrand/site-5.png"),
				name1: "丽姬凝润冰肌系列",
				color1: "black",
				img2: require("../assets/yiBrand/site-6.png"),
				name2: "一清堂套盒系列",
				color2: "old"
			},
			{
				img1: require("../assets/yiBrand/site-7.png"),
				name1: "一清堂特品系列",
				color1: "new",
				img2: require("../assets/yiBrand/site-8.png"),
				name2: "洁修养系列",
				color2: "clean"
			}

			],
		}
	},
	methods: {
		arrowClick(val) {
			if (val === 'next') {
				this.$refs.cardShow.next()
			} else {
				this.$refs.cardShow.prev()
			}
		},
		goList(id) {
			this.$router.push({ path: "/zhongList", query: { brandId: id } });
		},
		enterHome() {
			this.$router.push({ path: '/' });
		},
	}
}
</script>

<style scoped>

img{
	width: 100%;
}
.zhongContainer {
	margin: 0;
	padding: 0;
	position: relative;
}

.pageBoxOut2 {
	width: 90%;
	height: 100%;
	justify-content: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 0 auto;
	box-sizing: border-box;
}

/* 导航 */

/* 下拉菜单栏 选中 */
.elDropdown_active {
	background-color: #FFFFFF !important;
	color: #000000 !important;
}

.navBar {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	background: #FFFFFF;
	z-index: 999;
}

.router-link-active {
	background-color: #0F3F93 !important;
	color: #FFFFFF !important;
}

.navLogo {
	width: 10%;
	margin-left: 5em;
	cursor: pointer;
}

.navBarItem {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
}


.navBarItem li {

	list-style: none;

	float: left;

}

.brandLi a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #222222;
	line-height: 20px;
	padding-top: 1.6em !important;
	padding-bottom: 1.6em !important;
	padding-left: 2em;
	padding-right: 2em;
}

.navBarItem li a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #222222;
	line-height: 20px;
	padding-top: 1.4em;
	padding-bottom: 1.4em;
	padding-left: 1.4rem;
	padding-right: 1.4rem;
}

/* .elDropdown{
			margin-left: -7.5em;
			margin-top: -1em;
		} */

.elDropdown a {
	color: #111111;
	text-decoration: none;
}

.el-dropdown {
	vertical-align: top;
}

.el-dropdown+.el-dropdown {
	margin-left: 15px;
}

.el-icon-arrow-down {
	font-size: 12px;
}

.el-dropdown-link {
	cursor: pointer;
}

.el-icon-arrow-down {
	font-size: 12px;
}



/* 首图 */
.topImg {
	/* margin-top: 66px; */
	width: 100%;
	background-color: #fff;
	transition-property: all;
	text-align: center;
}

.topImg img {
	width: 100%;
	height: 100%;
	/* height: 462px; */
}


.customer {
	width: 100%;
	height: 80vh;
	position: relative;
	display: flex;
	flex-direction: row;
}

.leftImg {
	position: absolute;
	top: 13.4vh;
	left: 13.54vw;

	width: 31vw;
}

.rightText {
	width: 28.7vw;
	position: absolute;
	top: 25.6vh;
	right: 8.02vw;
}

.rightText .title {
	height: 2.315vh;
	font-family: Source Han Sans SC;
	font-weight: 400;
	font-size: 1.3vw;
	color: #023591;
	line-height: 2.315vh;
}

.rightText .content {
	margin-top: 3.6vh;
	width: 28.7vw;
	height: 27.4vh;
	font-family: Source Han Sans SC;
	font-weight: 400;
	font-size: 0.8vw;
	color: #727171;
	line-height: 3.8vh;
}

.fgLine {
	width: 100%;
	height: 4.35vh;
	background-color: #023591;
	text-align: center;
	line-height: 4.35vh;
	color: #fff;
	font-family: Source Han Sans SC;
	font-size: 0.833vw;
}

.recommend {
	position: relative;
	background-color: #F2F2F2;
	height: 200vh;

}

.white-background {
	background-color: #fff;
	height: 76vh;
}

.recImg {
	position: absolute;
	top: 15vh;
	right: 0;
	width: 86.2vw;
}


.series {
	position: absolute;
	bottom: 30vh;

	/* width: 100%; */
	margin-left: 10.7vw;
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	align-items: center;
}

.series .series-title .stitle {
	/* width: 257px; */
	height: 2.3vh;
	font-family: Source Han Sans SC;
	font-weight: 400;
	font-size: 1.3vw;
	color: #023591;
	line-height: 2.3vh;
	display: flex;
}

.upjia {
	margin-top: -0.8vh;
}

.series .series-title .scontent {
	margin-top: 4.07vh;
	width: 22.9vw;
	height: 8.6vh;
	font-family: Source Han Sans SC;
	font-weight: 400;
	font-size: 0.83vw;
	color: #727171;
	line-height: 3.6vh;
}

.series .series-title .more {
	width: 9vw;
	height: 3.14vh;
	margin-top: 4vh;
	border: 0.052vw solid #9D9C9C;
	text-align: center;
	line-height: 3.14vh;
	color: #727171;


}



.allSeries {
	/* width: 100%; */
	margin-left: 10.47vw;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
}



.allSeries .prev {
	/* background-color: #3F3A60; */
	width: 1.72vw;
	height: 5.37vh;
	z-index: 999;
	cursor: pointer;
}

.allSeries .prev img {
	width: 100%;
	height: 100%;
}

.allSeries .next {
	width: 1.72vw;
	height: 5.37vh;

	z-index: 999;
	cursor: pointer;
}

.allSeries .next img {
	width: 100%;
	height: 100%;
}

.allSeries .carousel {
	/* background-color: #000000; */
	padding: 0 3.7vw;
	width: 36.46vw;
	height: 44.44vh;

}

.allSeries .carousel .box {
	width: 100%;
	height: 50vh;
	display: flex;

	align-items: center;
	justify-content: space-between;
}


.allSeries .carousel .box .cover {
	width: 16.61vw;
	/* height: 41.76vh; */
	/* overflow: hidden; */
}

.allSeries .carousel .box .cover img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	/* transition: 0.2s; */
	cursor: pointer;
}

.allSeries .cover img:hover {
	/* transform: scale(1.1); */
}




/* pageBox2 */


.pageBox6 {
	height: 653px;
	width: 100%;
	background-color: #023591;
}

/* footer */
.footerBox {
	width: 90%;
	/* height: 287px; */
	background: #023591;
	/* position:absolute;
		 	bottom:0; */
	margin: 0 auto;
	flex-direction: column;
	z-index: 999;
}


.footerBoxHeader {
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-top: 2%;
}

.footerBoxHeaderLeft {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.footerBoxHeaderCenter {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 5em;
}

.footerBoxHeaderRight {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 5em;
}

.footerBoxHeaderMiddle {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.codeImg {
	width: 100%;
}

.codeText {
	font-size: 0.88em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #fff;
	line-height: 20px;
	margin-top: 0.5rem;
}



.footerLine {
	width: 79%;
	height: 1px;
	display: flex;
	background: #fff;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 1em;
}



.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 2rem;
}

.emailBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #fff;
	line-height: 20px;
}


.phoneBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #fff;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #fff;
	line-height: 20px;
	margin-top: 0.5rem;
}


.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: row;
	justify-content: center;
	margin-top: 1rem;
}



.footerLeft {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #fff;
	line-height: 24px;
}

.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #fff;
}

.footerLeft a:hover {
	color: #003F98;
}

.footerMiddle {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.footerMiddle span {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #fff;
	line-height: 24px;
}

.footerRight {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.footerRight li a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #fff;
	line-height: 28px;
}

.footerRight li {
	list-style: none;
}

.footerLast {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #fff;
	line-height: 28px;
	margin-left: 2em;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.875rm;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #fff;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerLast span {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #fff;
}

.footerMainBox {
	display: flex;
	flex-direction: row;
	margin: 0 auto;
	align-items: center;
	flex-direction: row;
	justify-content: center;
	margin-top: 2em;
}



.footerShop {
	list-style: none;
	position: relative;
}

.footerShop span{
	margin-right: 10px;
}
.footerShop span::after{
	content: '+';
	display:block;
	position: absolute;
	top: -6px;
	right: 43px;
}

.footerShop a {
	text-decoration: none;
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #fff;
	padding-left: 2em;
	line-height: 28px;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/zhongBrand.vue